import {QueryClient, useMutation, useQuery} from "react-query";
import axios, {AxiosError} from "axios";
import {Cart, CartItem, ColorResponse, PutCartCommand} from "./types";
import {groupBy} from "lodash";

export const queryClient = new QueryClient();

export const shopClient = axios.create({
    baseURL: "https://shop.metconlovers.com/",
    timeout: 60000,
});

const colorsQuery = () => {
    return shopClient.get(`/colors`)
        .then((data) => data.data)
        .then(data => groupBy(data, 'group'));
}

export const useColors = () => {
    return useQuery<ColorResponse>(`colors`, async () => colorsQuery());
};

export const useCart = () => {
    let sessionId = localStorage.getItem('SESSION_ID');
    if(!sessionId) {
        sessionId = Math.random().toString(); //TODO - change to uuid
        localStorage.setItem('SESSION_ID', sessionId);
    }
    return useQuery<Cart>(['cart', sessionId], async () =>
        shopClient.get(`/cart/${sessionId}`).then((data) => data.data),
    );
};

export const usePutToCart = () => {
    const sessionId = localStorage.getItem('SESSION_ID');
    return useMutation<Cart, AxiosError, PutCartCommand>(['cart', sessionId], async (item: PutCartCommand) =>
        shopClient.put(`/cart/${sessionId}`, item).then((data) => data.data),
    );
};

export const useRemoveProduct = (itemId: string) => {
    const sessionId = localStorage.getItem('SESSION_ID');
    return useMutation<Cart>(['cart', sessionId], async () =>
        shopClient.delete(`/cart/${sessionId}/${itemId}`).then((data) => data.data),
    );
};

export const useChangeQuantity = (itemId: string, quantity: number) => {
    const sessionId = localStorage.getItem('SESSION_ID');
    return useMutation<Cart>(['cart', sessionId], async () =>
        shopClient.put(`/cart/${sessionId}`, {itemId, quantity}).then((data) => data.data),
    );
};

export const useBuy = () => {
    const sessionId = localStorage.getItem('SESSION_ID');
    return useMutation<Cart>(['cart', sessionId], async () =>
        shopClient.post(`/cart/${sessionId}`).then((data) => data.data),
    );
};